/**
 * @description Gets the current time from the server and returns a date object
 * @returns {Promise<Date>} The current date
 * @category Utils
 */
export default async () => {
  const serverTime = await $fetch<{ timestamp: number }>('/fapi/server/time')
  return serverTime?.timestamp ? new Date(serverTime.timestamp) : new Date(0)
}
